export const themesList = [
  "간구", "감사", "거룩함", "격려", "결단", "경배", "계획", "고난", "고백", '교회', "골방", "교제", "구속", "구원",
  "긍휼", "기쁨", "기적", "기도", "나아감", "내어맡김", "닮음", "동행",
  "말씀", "믿음", "보혈", "보호", "복음", "봉헌", "부활", "부흥", "변화",
  "사랑", "사명", "선교", "선하심", "선포", "성령", "성화", "성탄", "소망", "순결", "순종",
  "십자가", "신뢰", "신앙", "신분", "신실함", "승리", "섬김", "예배",
  "예수님", "영광", "연단", "연합", "온전함", "용서", "위로",
  "의지", "은혜", "인내", "인도", "임재", "전능하심", "전도", "재림", "정결", "중보",
  "친밀함", "창조", "찬양", "천국", "충만", "축복", "탄생", "통치", "평안", "하나님", "하나님나라","함께하심", "헌신",
  "회개", "회복", "희생"
];


export const religiousbodyList = [
  "기독교대한감리회", "기독교대한성결교회", "기독교대한하나님의성회", "기독교한국침례회", "대한기독교나사렛성결회",
  "대한예수교장로회고신", "대한예수교장로회백석", "대한예수교장로회통합", "대한예수교장로회합동", "대한예수교장로회합신", "예수교대한성결교회", "한국기독교장로회", "독립교단(KAICAM)", "기타교단"];

export const locationList = ['서울','인천','경기', '강원', '대전','세종','충청','광주','전북','전남','대구','경북','울산','부산','경남','제주'];
export const sortList = ['담임','전임','준전임','파트'];

export const citydata = [
  {
    "city": "강원특별자치도",
    "subarea": [
      "춘천시",
      "원주시",
      "강릉시",
      "동해시",
      "태백시",
      "속초시",
      "삼척시",
      "홍천군",
      "횡성군",
      "영월군",
      "평창군",
      "정선군",
      "철원군",
      "화천군",
      "양구군",
      "인제군",
      "고성군",
      "양양군"
    ]
  },
  {
    "city": "경기도",
    "subarea": [
      "수원시",
      "성남시",
      "의정부시",
      "안양시",
      "부천시",
      "광명시",
      "평택시",
      "동두천시",
      "안산시",
      "고양시",
      "과천시",
      "구리시",
      "남양주시",
      "오산시",
      "시흥시",
      "군포시",
      "의왕시",
      "하남시",
      "용인시",
      "파주시",
      "이천시",
      "안성시",
      "김포시",
      "화성시",
      "광주시",
      "양주시",
      "포천시",
      "여주시",
      "연천군",
      "가평군",
      "양평군"
    ]
  },
  {
    "city": "경상남도",
    "subarea": [
      "창원시",
      "진주시",
      "통영시",
      "사천시",
      "김해시",
      "밀양시",
      "거제시",
      "양산시",
      "의령군",
      "함안군",
      "창녕군",
      "고성군",
      "남해군",
      "하동군",
      "산청군",
      "함양군",
      "거창군",
      "합천군"
    ]
  },
  {
    "city": "경상북도",
    "subarea": [
      "포항시",
      "경주시",
      "김천시",
      "안동시",
      "구미시",
      "영주시",
      "영천시",
      "상주시",
      "문경시",
      "경산시",
      "의성군",
      "청송군",
      "영양군",
      "영덕군",
      "청도군",
      "고령군",
      "성주군",
      "칠곡군",
      "예천군",
      "봉화군",
      "울진군",
      "울릉군"
    ]
  },
  {
    "city": "광주광역시",
    "subarea": [
      "동구",
      "서구",
      "남구",
      "북구",
      "광산구"
    ]
  },
  {
    "city": "대구광역시",
    "subarea": [
      "중구",
      "동구",
      "서구",
      "남구",
      "북구",
      "수성구",
      "달서구",
      "달성군",
      "군위군"
    ]
  },
  {
    "city": "대전광역시",
    "subarea": [
      "동구",
      "중구",
      "서구",
      "유성구",
      "대덕구"
    ]
  },
  {
    "city": "부산광역시",
    "subarea": [
      "중구",
      "서구",
      "동구",
      "영도구",
      "부산진구",
      "동래구",
      "남구",
      "북구",
      "해운대구",
      "사하구",
      "금정구",
      "강서구",
      "연제구",
      "수영구",
      "사상구",
      "기장군"
    ]
  },
  {
    "city": "서울특별시",
    "subarea": [
      "종로구",
      "중구",
      "용산구",
      "성동구",
      "광진구",
      "동대문구",
      "중랑구",
      "성북구",
      "강북구",
      "도봉구",
      "노원구",
      "은평구",
      "서대문구",
      "마포구",
      "양천구",
      "강서구",
      "구로구",
      "금천구",
      "영등포구",
      "동작구",
      "관악구",
      "서초구",
      "강남구",
      "송파구",
      "강동구"
    ]
  },
  {
    "city": "세종특별자치시",
    "subarea": []
  },
  {
    "city": "울산광역시",
    "subarea": [
      "중구",
      "남구",
      "동구",
      "북구",
      "울주군"
    ]
  },
  {
    "city": "인천광역시",
    "subarea": [
      "중구",
      "동구",
      "미추홀구",
      "연수구",
      "남동구",
      "부평구",
      "계양구",
      "서구",
      "강화군",
      "옹진군"
    ]
  },
  {
    "city": "전라남도",
    "subarea": [
      "목포시",
      "여수시",
      "순천시",
      "나주시",
      "광양시",
      "담양군",
      "곡성군",
      "구례군",
      "고흥군",
      "보성군",
      "화순군",
      "장흥군",
      "강진군",
      "해남군",
      "영암군",
      "무안군",
      "함평군",
      "영광군",
      "장성군",
      "완도군",
      "진도군",
      "신안군"
    ]
  },
  {
    "city": "전북특별자치도",
    "subarea": [
      "전주시",
      "군산시",
      "익산시",
      "정읍시",
      "남원시",
      "김제시",
      "완주군",
      "진안군",
      "무주군",
      "장수군",
      "임실군",
      "순창군",
      "고창군",
      "부안군"
    ]
  },
  {
    "city": "제주특별자치도",
    "subarea": [
      "제주시",
      "서귀포시"
    ]
  },
  {
    "city": "충청남도",
    "subarea": [
      "천안시",
      "공주시",
      "보령시",
      "아산시",
      "서산시",
      "논산시",
      "계룡시",
      "당진시",
      "금산군",
      "부여군",
      "서천군",
      "청양군",
      "홍성군",
      "예산군",
      "태안군"
    ]
  },
  {
    "city": "충청북도",
    "subarea": [
      "청주시",
      "충주시",
      "제천시",
      "보은군",
      "옥천군",
      "영동군",
      "증평군",
      "진천군",
      "괴산군",
      "음성군",
      "단양군"
    ]
  }
]